<!-- <header class="header"> -->
<nav style="background-color: #284867 !important; color: #F1F1F1" id="sidebar" >
    <!-- Sidebar Header-->
    <div  class="sidebar-header d-flex align-items-center">
      <div class="avatar"><a routerLink="myprofile"> <img src="/assets/user.jpg" alt="..." class="img-fluid rounded-circle"></a></div>
      <div class="title">
        <h1 class="h5">{{userData?.firstname}} {{userData?.lastname}} </h1>
        <p>Acct No: {{accountID}} </p>
        <p> {{role}} </p>
      </div>
    </div>
    <!-- Sidebar Navidation Menus--><span class="heading" style="color: #f1f1f1;">Menu</span>
    <ul class="list-unstyled">
            <li class="active"><a routerLink="home"> <i class="icon-home"></i>Dashboard </a></li>
            <li><a routerLink="wallet"> <i class="icon-bill"></i>My Wallet</a></li>
            <li><a routerLink="myprofile"> <i class="fa fa-user"></i>My Profile </a></li>
            <li><a routerLink="txns"> <i class="icon-padnote"></i>Thrift Transactions </a></li>
            <li><a type="button" data-toggle="modal" data-target="#joinThrift"> <i class="fa fa-group"></i>Join A Thrift </a></li>
            <!-- <li><a href="#exampledropdownDropdown" aria-expanded="false" data-toggle="collapse"> <i class="icon-windows"></i>Example dropdown </a>
              <ul id="exampledropdownDropdown" class="collapse list-unstyled ">
                <li><a href="#">Page</a></li>
                <li><a href="#">Page</a></li>
                <li><a href="#">Page</a></li>
              </ul>
            </li> -->
            <li><a routerLink="settings"> <i class="icon-settings"></i>Settings </a></li>
    </ul>
    <span class="heading" style="color: #f1f1f1;">Others</span>
    <ul class="list-unstyled">
      <li> <a routerLink="/myboard/organization" style="color: inherit;"> <i class="fa fa-bank"></i>My Organization </a></li>
      <li> <a routerLink="payment-details"> <i class="fa fa-credit-card-alt"></i>Payment Details</a></li>
      <li> <a href="#"> <i class="icon-light-bulb"></i>Membership </a></li>
      <li> <a href="#"> <i class="icon-chart"></i>Upcoming Feature </a></li>
      <li *ngIf="userLevel != 0"> <a routerLink="verify-me"> <i class="fa fa-bank"></i>Verify Account</a></li>
    </ul>
  </nav>

  <!-- </header> -->